// Cloudflare Image Transformations, served through the R2 custom domain
// images.hayleyandjarrett.com (Cloudflare-proxied), so resizing works in
// every environment — the site itself is on Netlify, where /cdn-cgi/image
// does not exist. Requires zone setting: Images → Transformations → enabled.
const IMAGES_ORIGIN = 'https://images.hayleyandjarrett.com'

const transform = (url, options) => {
  if (!url.startsWith(`${IMAGES_ORIGIN}/`)) return url
  const path = url.slice(IMAGES_ORIGIN.length + 1)
  return `${IMAGES_ORIGIN}/cdn-cgi/image/${options}/${path}`
}

export const thumb = (url, width) =>
  transform(url, `width=${width},fit=cover,quality=78,format=auto`)

// For full-screen viewing: constrain the longest edge, keep aspect ratio
export const large = (url) =>
  transform(url, 'width=2000,fit=scale-down,quality=85,format=auto')
